import { render, staticRenderFns } from "./inBox.vue?vue&type=template&id=4b4f6284&scoped=true&"
import script from "./inBox.vue?vue&type=script&lang=js&"
export * from "./inBox.vue?vue&type=script&lang=js&"
import style0 from "./inBox.vue?vue&type=style&index=0&id=4b4f6284&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4f6284",
  null
  
)

export default component.exports